import React, { useState } from "react";

// Array of tenant objects with additional fields
const tenants = [
  {
    id: "T001",
    name: "Timothy Ndiritu",
    dateJoined: "April 2024",
    apartmentNumber: "A15",
    email: "timothy.ndiritu@example.com",
    phoneNumber: "+254700123456",
    houseType: "2 Bedroom",
    nationalID: "12345678",
  },
  {
    id: "T002",
    name: "John Doe",
    dateJoined: "March 2024",
    apartmentNumber: "B10",
    email: "john.doe@example.com",
    phoneNumber: "+254700654321",
    houseType: "3 Bedroom",
    nationalID: "12345678",
  },
  {
    id: "T003",
    name: "Jane Smith",
    dateJoined: "February 2024",
    apartmentNumber: "C20",
    email: "jane.smith@example.com",
    phoneNumber: "+254700987654",
    houseType: "1 Bedroom",
    nationalID: "12345678",
  },
];

// Define the styles object
const styles = {
  tenantList: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  individualTenant: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px",
    backgroundColor: "white",
    boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.28)",
    padding: "7px 15px",
    borderRadius: "10px",
    alignItems: "center",
    cursor: "pointer",
  },
  left: {
    display: "flex",
    gap: "15px",
  },
  shape: {
    width: "35px",
    height: "35px",
    backgroundColor: "#0B2C3C",
    borderRadius: "50%",
  },
  nameAndDate: {
    display: "flex",
    flexDirection: "column",
  },
  name: {
    fontSize: "18px",
    fontWeight: "300",
  },
  dateJoined: {
    fontSize: "14px",
    fontFamily: '"Roboto", sans-serif',
    fontWeight: "200",
    color: "#A8B4CC",
    marginTop: "2px",
  },
  end: {
    fontSize: "16px",
    fontWeight: "400",
  },
  extraInfo: {
    width: "100%",
    margin: "20px 0",
    padding: "1rem",
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  extraInfoTitle: {
    fontSize: "18px",
    fontFamily: '"Karla", sans-serif',
    fontWeight: "500",
    marginBottom: "10px",
  },
  detailsAndTitle: {
    display: "flex",
    width: "90%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "5px",
  },
  tile: {
    fontSize: "16px",
    fontFamily: '"Poppins", sans-serif',
    fontWeight: "200",
  },
  details: {
    fontWeight: "400",
    fontSize: "16px",
    fontFamily: '"Poppins", sans-serif',
  },
  button: {
    backgroundColor: "#0B2C3C",
    color: "white",
    padding: "7px 10px",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop: "10px",
    fontSize: "14px",
  },
};

const TenantsList = ({ handleShowModal, setTenantData }) => {
  const [expandedTenantIndex, setExpandedTenantIndex] = useState(null);

  const toggleExpand = (index) => {
    setExpandedTenantIndex(expandedTenantIndex === index ? null : index);
  };

  return (
    <div style={styles.tenantList}>
      {tenants.map((tenant, index) => (
        <div key={index} style={{ width: "100%" }}>
          <div
            style={styles.individualTenant}
            onClick={() => toggleExpand(index)}
          >
            <div style={styles.left}>
              <div style={styles.shape}></div>
              <div style={styles.nameAndDate}>
                <div style={styles.name}>{tenant.name}</div>
                <div style={styles.dateJoined}>{tenant.dateJoined}</div>
              </div>
            </div>
            <div style={styles.end}>{tenant.apartmentNumber}</div>
          </div>
          {/* Expanded section */}
          {expandedTenantIndex === index && (
            <div style={styles.extraInfo}>
              <div style={styles.extraInfoTitle}>Tenant Details</div>
              <div style={styles.detailsAndTitle}>
                <div style={styles.tile}>Tenant ID:</div>
                <div style={styles.details}>{tenant.id}</div>
              </div>

              <div style={styles.detailsAndTitle}>
                <div style={styles.tile}>Phone Number:</div>
                <div style={styles.details}>{tenant.phoneNumber}</div>
              </div>
              <div style={styles.detailsAndTitle}>
                <div style={styles.tile}>National id Number:</div>
                <div style={styles.details}>{tenant.nationalID}</div>
              </div>
              <div style={styles.detailsAndTitle}>
                <div style={styles.tile}>House Type:</div>
                <div style={styles.details}>{tenant.houseType}</div>
              </div>
              <div style={styles.detailsAndTitle}>
                <div style={styles.tile}>Email:</div>
                <div style={{ ...styles.details, fontSize: "14px" }}>
                  {tenant.email}
                </div>
              </div>
              <div
                style={styles.button}
                onClick={() => {
                  handleShowModal("modify tenant");
                  setTenantData({
                    id: tenant.id,
                    name: tenant.name,
                    dateJoined: tenant.dateJoined,
                    apartmentNumber: tenant.apartmentNumber,
                    email: tenant.email,
                    houseType: tenant.houseType,
                    firstName: tenant.name.split(" ")[0],
                    lastName: tenant.name.split(" ")[1],
                    phoneNumber: "123-456-7890",
                    nationalID:tenant.nationalID
                  });
                }}
              >
                Edit Tenant
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default TenantsList;
